
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestbabyformulalawyers/privacy-policy",
      function () {
        return require("private-next-pages/bestbabyformulalawyers/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bestbabyformulalawyers/privacy-policy"])
      });
    }
  